import {from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import type {Feature, GeoMap} from '@/interfaces/geo/GeoMap.interface';

declare const Dabaskartes: GeoMap;

export default class MapFeaturesService {
    private static instance: MapFeaturesService;
    private localAllFeatures: Feature[] = [];

    public static getInstance(): MapFeaturesService {
        if (!MapFeaturesService.instance) {
            MapFeaturesService.instance = new MapFeaturesService();
        }
        return MapFeaturesService.instance;
    }

    public allFeatures(): Feature[] {
        return this.localAllFeatures;
    }

    public loadAllFeatures(layerId: string): Observable<void> {
        return from(Dabaskartes.getAllFeatures(layerId)).pipe(
            map((features: Feature[]): void => {
                this.localAllFeatures = features;
            })
        );
    }
}
